<template>
  <ticket-transfer-dropdown :ticket="ticket" @success="onTransferSuccess">
    <template #trigger>
      <woot-button
        variant="clear"
        color-scheme="secondary"
        size="tiny"
        icon="more-vertical"
      />
    </template>
  </ticket-transfer-dropdown>
</template>

<script>
import TicketTransferDropdown from '../../../contacts/components/TicketTransferDropdown.vue';

export default {
  name: 'TicketTransferMenu',
  components: { TicketTransferDropdown },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onTransferSuccess(updatedTicket) {
      this.$emit('transfer-success', updatedTicket);
    },
  },
};
</script>

